import { enumParser } from '#validation/common/parsers';
import { MemberEncryptionType } from '../constants';
export const memberEncryptionTypeParser = enumParser(MemberEncryptionType);
